import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsCategoriesBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Categories</div>
          <div className="text">
            Posts can be assigned categories. Each category is for a specific board,
            not&nbsp;company-wide.
          </div>
          <div className="text">
            Our API allows you to list, and retrieve categories. You can also change categories
            of&nbsp;posts.
          </div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
